export default "static/media/canvasPlus.5fdd9e7.svg"